import { useConsumerById } from '../consumer';
import { useCurrentUser } from '../user';

export const useCurrentUserEmployee = () => {
  const { user } = useCurrentUser();

  return useConsumerById(user?.employee?.id);
};
